export default __webpack_public_path__ + "static/media/04 Personal Details – 1.e68d4d1c.png";